import type { KeyboardEvent } from "react";
import { useTranslation } from "react-i18next";

import { Button } from "@/components/_atoms/button";
import { TeamBrowseAllDialog } from "@/domain/team/components/team-browse-all-dialog";
import { MagnifyingGlassPlusIcon } from "@heroicons/react/24/solid";

interface SidebarJoinTeamButtonProps {
  workspaceId: string;
  userId: string;
}

export const SidebarJoinTeamButton = ({ workspaceId, userId }: SidebarJoinTeamButtonProps) => {
  const { t } = useTranslation("common");

  function handleKeyDown(event: KeyboardEvent<HTMLButtonElement>) {
    if (event.key === "Enter" || event.key === " ") {
      event.preventDefault();
      event.currentTarget.click();
    }
  }

  return (
    <TeamBrowseAllDialog asChild={true} workspaceId={workspaceId} userId={userId} className="w-full">
      <Button
        variant="ghost"
        className="relative block h-auto w-full cursor-pointer rounded-md p-0 text-sm font-normal hover:bg-transparent focus-visible:outline-2 focus-visible:-outline-offset-2 focus-visible:outline-focus"
        aria-label={t("sidebar.joinTeamAriaLabel")}
        onKeyDown={handleKeyDown}
      >
        <div className="select-none text-sm">
          <div className="relative flex h-8 items-center overflow-hidden text-ellipsis rounded-md pb-0 pl-1.5 pr-0.5 pt-0 hover:bg-foreground/3 hover:text-accent-foreground">
            <MagnifyingGlassPlusIcon className="mr-2 h-3.5 w-3.5 text-muted-foreground" />
            {t("sidebar.joinTeam")}
          </div>
        </div>
      </Button>
    </TeamBrowseAllDialog>
  );
};
